import { ModalDialog } from './modal-dialog';

/**
 * Shared remove-flow for admin data-grid rows: derives the row, remove-url and
 * id from the clicked element, asks for confirmation with the styled dialog
 * and POSTs the removal. `onRemoved` runs with the removed $row on success.
 */
export function confirmRemoveRow(source: HTMLElement, message: string, onRemoved: ($row: JQuery) => void) {
	var $row = $(source).closest('[data-role="report-row"]');
	var $table = $(source).closest('[data-role="section-table"]');
	var url = $table.data('remove-url');
	if (!url) {
		throw 'remove-url is missing';
	}
	var id = $row.data('id');
	if (!id) {
		throw 'id is missing';
	}
	ModalDialog.confirm(message).then(function (confirmed) {
		if (!confirmed) {
			return;
		}
		$.post(url, { id: id }).done(function () {
			onRemoved($row);
		});
	});
}

/**
 * Post-remove behavior for grids with a "display deleted" toggle: keep the row
 * visible marked as removed, or refresh the grid.
 */
export function markRemovedOrRefresh(grid: IDataGrid, $row: JQuery) {
	var $displayDeleted = grid.toolbar.find('[name="display-deleted"]');
	if ($displayDeleted.is(':checked')) {
		$row.attr('data-is-removed', 'true');
	} else {
		grid.dataGrid('refresh');
	}
}
